<template>
    <f7-page
        name="Admin"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="Admin"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack"
                />
            </f7-nav-left>
            <f7-nav-title>Admin Products</f7-nav-title>
        </f7-navbar>

        <f7-block-title>Setup</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >

            <f7-list-item
                v-if="isPgap"
                @click="showRCProducts()"
            >RC debug products</f7-list-item>
            <f7-list-item
                v-if="!isPgap"
                @click="togglePaymentMode()"
            >Stripe payment mode ({{ paymentMode }})</f7-list-item>
        </f7-list>

        <f7-block-title>Products SKUs</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <template v-for="product in products">
                <f7-card
                    v-if="isForThisPlatform(product) && product.published"
                    :key="product.id"
                >
                    <f7-card-header>ProductId: {{ product.id }} {{ product.sku }} </f7-card-header>
                    <f7-card-content>
                        <p>{{ product.description }}</p>
                        <p v-if="isPgap">Valid in RC: {{ isValid(product) ? 'Valid' : 'Invalid' }}</p>
                        <p v-if="isPgap && isValid(product)">Eligible for free trial*: {{ exiligbleForTrial(product) ? 'Yes' : 'No' }}
                        </p>
                        <p>Trial length: {{ product.freeDays }} days</p>

                    </f7-card-content>
                    <f7-card-footer>
                        <f7-link @click="isValid(product) ? buyProduct(product) : invalidProduct(product)">
                            Buy {{ isPgap ? RCProductDescription(product) : StripeProductDescription(product) }}
                        </f7-link>
                    </f7-card-footer>
                </f7-card>
            </template>
        </f7-list>
        <p v-if="isPgap">* you only get one trial or intro offer</p>
        <f7-block-title v-if="isPgap">Products Revenuecat</f7-block-title>
        <!-- <f7-list
            inset
            class="bordered"
        >
            <f7-list-item
                v-for="(product, index) in RCproducts"
                :key="`rc-${index}`"
            >{{ product }}</f7-list-item>
        </f7-list> -->
        <f7-block v-if="isPgap">
            {{ RCproducts }}
        </f7-block>
    </f7-page>
</template>

<script>
export default {
    store: [
        'api',
        'user',
        'products',
        'RCproducts'
    ],
    data () {
        return {
            paymentMode: 'sandbox',
            text: '',
            isProcessing: false,
            isProcessingStripe: false,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
    },
    created: function () {

    },
    mounted: function () {
        this.$events.fire('subscriptions-sync');
    },
    methods: {
        goBack: function () {
            if (f7.views['main'].router.history.length === 1) {
                return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            }
            return f7.views['main'].router.back();
        },
        isForThisPlatform: function (product) {
            if (pgap && ['app_store', 'play_store'].indexOf(product.provider) > -1) {
                // is mobile
                if (product.provider === 'app_store' && device.platform === 'iOS') {
                    return true;
                }
                if (product.provider === 'play_store' && device.platform === 'Android') {
                    return true;
                }
                return false;
            }
            if (!pgap && product.provider === 'stripe') {
                // is web
                if (this.paymentMode === 'sandbox' && product.sandbox) {
                    return true;
                }
                if (this.paymentMode !== 'sandbox' && !product.sandbox) {
                    return true;
                }
                return false;
            }
            return false;
        },
        RCProduct: function (product) {
            for (let i = 0; i < this.RCproducts.current.availablePackages.length; i++) {
                const p = this.RCproducts.current.availablePackages[i];
                if (product.identifier === p.product.identifier) {
                    return p;
                }
            }
            return false;
        },
        RCProductDescription: function (product) {
            let p = this.RCProduct(product);
            if (!p) return '';
            let introPrice = ''
            if (p.product.introPrice) {
                introPrice += `${p.product.introPrice.priceString} ${p.product.introPrice.periodNumberOfUnits} ${p.product.introPrice.periodUnit} then `
            }
            return `${introPrice} ${p.product.priceString} ${p.packageType}`;
        },
        StripeProductDescription: function (product) {
            let introPrice = ''
            if (product.id === 12 || product.id === 11) {
                introPrice += `$49.99 for the first year then `
            }
            return `${introPrice} $${product.price} ${product.term}`;
        },
        isValid: function (product) {
            if (!this.isForThisPlatform(product)) return false;
            if (pgap && !this.RCProduct(product)) return false;
            if (!pgap && !product.identifier) return false;
            return true;
        },
        invalidProduct: function (product) {
            f7.dialog.alert(`Product REF:${product.id} is not available on your current store.`);
        },
        buyProduct: function (product) {
            this.$events.fire('subscriptions-purchase', product);
        },
        togglePaymentMode: function () {
            if (!localStore.getItem('testPayment')) {
                localStore.setItem('testPayment', true);
                this.paymentMode = 'sandbox';
            } else {
                localStore.removeItem('testPayment');
                this.paymentMode = 'production';
            }
        },
        showRCProducts: function () {
            f7.popup.create({
                content: `<div class="popup" style="overflow-y: scroll;"><br><br><p><a href="#" class="link popup-close">Close admin detail</a></p>
                                    <pre>${JSON.stringify(this.RCproducts, null, 2)}</pre></div>`,
            }).open();
        },

    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
</style>
